
interface IProps { }

export const GreenEmblem: React.FC<IProps> = () => {
  return (
    <svg width="100%" height="100%" viewBox="0 0 518 544" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M-109.695 818.968L-79.6865 867.019L517.348 497.823L487.361 449.619C431.671 360.016 402.165 256.688 402.165 151.268C402.165 45.8468 431.671 -57.4811 487.361 -147.084L517.424 -195.298L-79.7191 -564.376L-109.728 -516.335C-234.625 -315.92 -300.815 -84.6548 -300.815 151.316C-300.815 387.288 -234.625 618.553 -109.728 818.968L-109.695 818.968Z" fill="#224946" />
    </svg>
  )
}